import { action, Action } from 'typesafe-actions'

export enum RefinanciamentoTypes {
  RESET = 'RESET',
}

export const reset = (): Action => action(RefinanciamentoTypes.RESET)
